export default __webpack_public_path__ + "static/media/help.6dca0d1a.svg";